/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderRequestItemPendingStock {
  brandEquity?: number;
  category?: string;
  costPrice?: number;
  dateCreated?: Date;
  defaultImageURL?: string;
  email?: string;
  externalId?: number;
  firstName?: string;
  glamId?: string;
  inStockAcquisition?: number;
  internalEAN?: string;
  invoicePrice?: number;
  lastName?: string;
  personId?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  salePrice?: number;
  shippingOrderId?: number;
  shippingOrderItemId?: number;
  shippingOrderRequestId?: number;
  shippingOrderStatus?: number;
  ticketDetail?: string;
  ticketId?: number;
  weight?: number;
}
